import React, { useContext, useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AppContext } from '../../context/AppContext';
import { Sancion, Reclamacion } from '../../models/types';
import { sancionServiceFirestore } from '../../services/SancionServiceFirestore';
import { reclamacionServiceFirestore } from '../../services/ReclamacionServiceFirestore';
import { FaSave, FaArrowLeft, FaRobot, FaUserEdit, FaGavel, FaExclamationTriangle } from '../../components/Icons';
import { FaList, FaInfoCircle, FaArrowUp, FaArrowDown, FaFileAlt, FaImage } from 'react-icons/fa';
import { theme } from '../../theme';

// Sistema de códigos de sanciones
const CODIGOS_SANCIONES = {
  'OTRA': { descripcion: 'DEFINIR', puntos: 0 },
  'LANCE': { descripcion: 'SIN SANCIÓN', puntos: 0 },
  '1.1': { descripcion: 'SANCIONADO CON WARNING', puntos: 0 },
  '1.2': { descripcion: 'SANCIONADO CON WARNING', puntos: 0 },
  '1.3': { descripcion: 'SANCIONADO CON WARNING', puntos: 0 },
  '1.4': { descripcion: 'SANCIONADO CON WARNING', puntos: 0 },
  '1.5': { descripcion: 'SANCIONADO CON WARNING', puntos: 0 },
  '2.1': { descripcion: 'SANCIÓN DE-1 PUNTO + WARNING', puntos: -1 },
  '2.2': { descripcion: 'SANCIÓN DE -1 PUNTO + WARNING', puntos: -1 },
  '2.3': { descripcion: 'SANCIÓN DE -1 PUNTO + WARNING', puntos: -1 },
  '2.4': { descripcion: 'SANCIÓN DE -1 PUNTO + WARNING', puntos: -1 },
  '2.5': { descripcion: 'SANCIÓN DE -1 PUNTO + WARNING', puntos: -1 },
  '3.1': { descripcion: 'SANCIÓN DE -2 PTS. + WARNING', puntos: -2 },
  '3.2': { descripcion: 'SANCIÓN DE -2 PTS. + WARNING', puntos: -2 },
  '3.3': { descripcion: 'SANCIÓN DE -2 PTS. + WARNING', puntos: -2 },
  '3.4': { descripcion: 'SANCIÓN DE -2 PTS. + WARNING', puntos: -2 },
  '3.5': { descripcion: 'SANCIÓN DE -2 PTS. + WARNING', puntos: -2 },
  '4.1': { descripcion: 'SANCIÓN DE +DT', puntos: -3 },
  '4.2': { descripcion: 'SANCIÓN DE +DT', puntos: -3 },
  '4.3': { descripcion: 'SANCIÓN DE +DT', puntos: -3 },
  '4.4': { descripcion: 'SANCIÓN DE +DT', puntos: -3 },
  '4.5': { descripcion: 'SANCIÓN DE +DT', puntos: -3 },
  '5.1': { descripcion: 'SANCIÓN DE +DT + DQ', puntos: -4 },
  '5.2': { descripcion: 'SANCIÓN DE +DT + DQ', puntos: -4 },
  '5.3': { descripcion: 'SANCIÓN DE +DT + DQ', puntos: -4 },
  '5.4': { descripcion: 'SANCIÓN DE +DT + DQ', puntos: -4 },
  '5.5': { descripcion: 'SANCIÓN DE +DT + DQ', puntos: -4 },
  '6.1': { descripcion: 'SANCIÓN DE +DT + DQ + NQ', puntos: -5 },
  '6.2': { descripcion: 'SANCIÓN DE +DT + DQ + NQ', puntos: -5 },
  '6.3': { descripcion: 'SANCIÓN DE +DT + DQ + NQ', puntos: -5 },
  '6.4': { descripcion: 'SANCIÓN DE +DT + DQ + NQ', puntos: -5 },
  '6.5': { descripcion: 'SANCIÓN DE +DT + DQ + NQ', puntos: -5 },
  '7.1': { descripcion: 'SANCIÓN DE – 1 PTS. + WARNING', puntos: -1 },
  '7.2': { descripcion: 'SANCIÓN A DETERMINAR', puntos: 0 },
  '7.3': { descripcion: 'SANCIÓN A DETERMINAR', puntos: 0 },
  '7.4': { descripcion: 'SANCIÓN DE – 2 PTS. + DT +WARNING', puntos: -2 },
  '7.5': { descripcion: 'SANCIÓN DE +DT + DQ', puntos: -4 },
  '8.1': { descripcion: 'SANCIÓN DE -3 PTS', puntos: -3 },
  '8.2': { descripcion: 'SANCIÓN DE +DT + DT', puntos: -4 },
  '8.3': { descripcion: 'SANCIÓN DE DQ', puntos: -3 },
  '9.1': { descripcion: '[AJUSTE FPS, REESTABLECIDO +1 PT]', puntos: 1 },
  '9.2': { descripcion: '[AJUSTE FPS, REESTABLECIDOS +2 PTS]', puntos: 2 },
  '9.3': { descripcion: '[AJUSTE FPS, REESTABLECIDOS +3 PTS]', puntos: 3 },
  '9.4': { descripcion: '[AJUSTE FPS, SANCIONADO CON -1 PT]', puntos: -1 },
  '9.5': { descripcion: '[AJUSTE FPS, SANCIONADO CON -2 PTS]', puntos: -2 },
  '9.6': { descripcion: '[AJUSTE FPS, SANCIONADO CON -3 PTS]', puntos: -3 },
  '0.1': { descripcion: 'COMISARIOS2: LEVANTAMOS SANCIONADO CON WARNING', puntos: 0 },
  '0.2': { descripcion: 'COMISARIOS2: LEVANTAMOS SANCIÓN. DEVOLVEMOS +1 PUNTO - WARNING', puntos: 1 },
  '0.3': { descripcion: 'COMISARIOS2: LEVANTAMOS SANCIÓN. DEVOLVEMOS +2 PTS. - WARNING', puntos: 2 },
  '0.4': { descripcion: 'COMISARIOS2: LEVANTAMOS SANCIÓN. DEVOLVEMOS -DT', puntos: 3 },
  '0.5': { descripcion: 'COMISARIOS2: LEVANTAMOS SANCIÓN. DEVOLVEMOS -DT -DQ', puntos: 4 },
  '0.6': { descripcion: 'COMISARIOS2: LEVANTAMOS SANCIÓN. DEVOLVEMOS -DT -DQ -NQ', puntos: 5 },
  '0.7': { descripcion: 'COMISARIOS: EL PILOTO SUMA PUNTOS', puntos: 1 }
};

const Container = styled.div`
  padding: 24px;
  max-width: 1280px;
  margin: 0 auto;
  background-color: ${theme.colors.background.default};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

const Title = styled.h1`
  color: ${theme.colors.primary.main};
  font-weight: ${theme.typography.fontWeights.bold};
  font-size: 2.2rem;
  position: relative;
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 60px;
    height: 4px;
    background-color: ${theme.colors.secondary.main};
    border-radius: 2px;
  }
  
  svg {
    margin-right: 16px;
    color: ${theme.colors.secondary.main};
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
`;

const Button = styled.button`
  background-color: ${theme.colors.secondary.main};
  color: ${theme.colors.secondary.contrastText};
  border: none;
  border-radius: ${theme.borderRadius.small};
  padding: 12px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: ${theme.typography.fontWeights.medium};
  transition: all 0.3s ease;
  box-shadow: ${theme.shadows.small};
  
  &:hover {
    background-color: ${theme.colors.secondary.dark};
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
  }
  
  svg {
    margin-right: 10px;
    font-size: 1.1rem;
  }
`;

const BackButton = styled(Button)`
  background-color: ${theme.colors.primary.main};
  
  &:hover {
    background-color: ${theme.colors.primary.dark};
  }
`;

const Form = styled.form`
  background-color: ${theme.colors.background.paper};
  border-radius: ${theme.borderRadius.medium};
  padding: 28px;
  box-shadow: ${theme.shadows.medium};
  margin-bottom: 32px;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

const FormGroup = styled.div`
  margin-bottom: 24px;
`;

const Card = styled.div`
  background-color: ${theme.colors.background.paper};
  border-radius: ${theme.borderRadius.medium};
  padding: 28px;
  box-shadow: ${theme.shadows.medium};
  margin-bottom: 28px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: ${theme.shadows.large};
  }
`;

const CardTitle = styled.h2`
  color: ${theme.colors.primary.main};
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  font-weight: ${theme.typography.fontWeights.semibold};
  
  svg {
    margin-right: 12px;
    color: ${theme.colors.secondary.main};
  }
`;

const Badge = styled.span<{ $type: 'auto' | 'manual' }>`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
  background-color: ${props => props.$type === 'auto' ? theme.colors.info.main : theme.colors.secondary.main};
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  
  svg {
    margin-right: 5px;
  }
`;

const ActionButton = styled(Button)`
  margin-top: 10px;
  background-color: ${theme.colors.primary.main};
  
  &:hover {
    background-color: ${theme.colors.primary.dark};
  }
`;

// Componentes para la guía de sanciones
const GuideSection = styled.div`
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const GuideSectionTitle = styled.h4`
  font-size: 1rem;
  color: ${theme.colors.primary.main};
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 8px;
    color: ${theme.colors.secondary.main};
  }
`;

const GuideList = styled.ul`
  padding-left: 20px;
  margin: 10px 0;
  
  li {
    margin-bottom: 8px;
  }
`;

const ComparisonTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
  
  th, td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #eee;
  }
  
  th {
    background-color: ${theme.colors.background.default};
    font-weight: ${theme.typography.fontWeights.semibold};
    color: ${theme.colors.primary.main};
  }
  
  tr:nth-child(even) {
    background-color: ${theme.colors.background.default};
  }
  
  .automatic {
    color: ${theme.colors.secondary.main};
  }
  
  .manual {
    color: ${theme.colors.primary.main};
  }
`;

const Checkbox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  input {
    margin-right: 10px;
  }
`;

const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  font-weight: ${theme.typography.fontWeights.semibold};
  color: ${theme.colors.text.primary};
  font-size: 1rem;
`;

const InfoMessage = styled.div`
  background-color: rgba(15, 52, 96, 0.05);
  border-left: 4px solid ${theme.colors.primary.main};
  color: ${theme.colors.text.primary};
  padding: 15px 20px;
  margin-bottom: 25px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  line-height: 1.6;
  font-size: 1rem;
`;

const WarningMessage = styled.div`
  background-color: rgba(228, 49, 46, 0.05);
  border-left: 4px solid ${theme.colors.secondary.main};
  color: ${theme.colors.text.primary};
  padding: 15px 20px;
  margin-bottom: 25px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  line-height: 1.6;
  font-size: 1rem;
`;

const GuideCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  border-top: 4px solid #101325;
  overflow: hidden;
`;

const GuideHeader = styled.div`
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const GuideTitle = styled.h3`
  font-size: 1.2rem;
  color: #101325;
  margin: 0;
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 10px;
  }
`;

const SanctionCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin-top: 20px;
  @media (max-width: 1600px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const SanctionCategoryCard = styled.div`
  background-color: #4b4f58;
  color: white;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const CategoryHeader = styled.div`
  padding: 10px;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.9rem;
`;

const CategoryPenalty = styled.div`
  padding: 5px 10px;
  text-align: center;
  background-color: rgba(0,0,0,0.2);
  font-weight: bold;
  font-size: 1rem;
`;

const SanctionsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  font-size: 0.9rem;
  
  th, td {
    padding: 8px 10px;
    text-align: left;
    border: 1px solid #ddd;
  }
  
  th {
    background-color: #f2f2f2;
    font-weight: bold;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  tr:hover {
    background-color: #f0f0f0;
  }
  
  td:first-child {
    font-weight: bold;
    width: 50px;
  }
  
  td:last-child {
    font-weight: bold;
    color: #e4312e;
    width: 180px;
  }
`;

// Estilos para la tarjeta de reclamación
const ReclamacionCard = styled.div`
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const ReclamacionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background-color: ${theme.colors.secondary.light};
  color: ${theme.colors.text.primary};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${theme.colors.secondary.main};
    color: white;
  }
`;

const ReclamacionBody = styled.div`
  padding: 15px;
  background-color: white;
`;

const ReclamacionInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
  margin-bottom: 15px;
`;

const ReclamacionInfoItem = styled.div`
  padding: 5px 0;
`;

const ReclamacionDescription = styled.div`
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  white-space: pre-line;
`;

const ReclamacionEvidencias = styled.div`
  margin-top: 15px;
  
  ul {
    list-style-type: none;
    padding-left: 10px;
    margin-top: 5px;
  }
  
  li {
    margin-bottom: 5px;
  }
  
  a {
    color: ${theme.colors.primary.main};
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: ${theme.borderRadius.small};
  font-size: 16px;
  transition: all 0.3s ease;
  background-color: ${theme.colors.background.default};
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.secondary.main};
    box-shadow: 0 0 0 3px rgba(228, 49, 46, 0.15);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: ${theme.borderRadius.small};
  font-size: 16px;
  min-height: 120px;
  resize: vertical;
  transition: all 0.3s ease;
  background-color: ${theme.colors.background.default};
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.secondary.main};
    box-shadow: 0 0 0 3px rgba(228, 49, 46, 0.15);
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: ${theme.borderRadius.small};
  font-size: 16px;
  transition: all 0.3s ease;
  background-color: ${theme.colors.background.default};
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.secondary.main};
    box-shadow: 0 0 0 3px rgba(228, 49, 46, 0.15);
  }
`;

const SancionDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { data, loadData } = useContext(AppContext);
  const [sancion, setSancion] = useState<Sancion | null>(null);
  const [reclamacion, setReclamacion] = useState<Reclamacion | null>(null);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    puntosPenalizacion: -2,
    socioId: '',
    carreraId: '',
    fechaAplicacion: '',
    automatica: false,
    codigoSancion: '',
    reclamacionId: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [guideOpen, setGuideOpen] = useState(false);
  const [reclamacionDetallesOpen, setReclamacionDetallesOpen] = useState(true);
  
  // Cargar datos de la sanción o reclamación
  useEffect(() => {
    const loadSancion = async () => {
      if (id === 'new') {
        // Nueva sanción
        setSancion(null);
        
        // Verificar si hay un socio preseleccionado o una reclamación asociada
        const params = new URLSearchParams(location.search);
        const socioId = params.get('socio');
        const carreraId = params.get('carrera');
        const auto = params.get('auto') === 'true';
        const reclamacionId = params.get('reclamacion');
        
        // Si hay una reclamación asociada, cargar sus datos
        if (reclamacionId) {
          try {
            setLoading(true);
            const reclamacionData = await reclamacionServiceFirestore.getById(reclamacionId);
            
            if (reclamacionData) {
              setReclamacion(reclamacionData);
              
              // Determinar el tipo de incidente para sugerir un código de sanción
              let codigoSugerido = '';
              if (reclamacionData.tipoIncidente === 'golpe') {
                codigoSugerido = '2.2'; // Accidente leve
              } else if (reclamacionData.tipoIncidente === 'salida_pista') {
                codigoSugerido = '3.4'; // Reincorporarse a pista
              } else if (reclamacionData.tipoIncidente === 'bloqueo') {
                codigoSugerido = '1.3'; // Incumplimiento cambio de trazada
              } else if (reclamacionData.tipoIncidente === 'comportamiento_antideportivo') {
                codigoSugerido = '7.1'; // Puntos a restar determinados por comisarios
              }
              
              // Usar el código sugerido para obtener la descripción y puntos
              const sancionSugerida = codigoSugerido ? CODIGOS_SANCIONES[codigoSugerido as keyof typeof CODIGOS_SANCIONES] : null;
              
              setFormData({
                nombre: `Sanción por ${reclamacionData.motivo}`,
                descripcion: `Sanción aplicada a raíz de la reclamación: ${reclamacionData.descripcion}`,
                puntosPenalizacion: sancionSugerida ? sancionSugerida.puntos : -2,
                socioId: reclamacionData.reclamadoSocioId,
                carreraId: reclamacionData.carreraId,
                fechaAplicacion: new Date().toISOString().split('T')[0],
                automatica: false,
                codigoSancion: codigoSugerido,
                reclamacionId: reclamacionId
              });
            } else {
              setError('No se encontró la reclamación solicitada');
            }
          } catch (err) {
            console.error('Error al cargar la reclamación:', err);
            setError('Error al cargar la reclamación');
          } finally {
            setLoading(false);
          }
        } else {
          // Si no hay reclamación, usar los parámetros normales
          setFormData({
            nombre: '',
            descripcion: '',
            puntosPenalizacion: -2,
            socioId: socioId || '',
            carreraId: carreraId || '',
            fechaAplicacion: new Date().toISOString().split('T')[0],
            automatica: auto,
            codigoSancion: '',
            reclamacionId: ''
          });
        }
      } else if (id) { // Asegurarse de que id no sea undefined
        // Sanción existente
        try {
          setLoading(true);
          const sancionExistente = await sancionServiceFirestore.getById(id);
          
          if (sancionExistente) {
            setSancion(sancionExistente);
            
            // Si la sanción tiene una reclamación asociada, cargarla
            if (sancionExistente.reclamacionId) {
              try {
                const reclamacionData = await reclamacionServiceFirestore.getById(sancionExistente.reclamacionId);
                if (reclamacionData) {
                  setReclamacion(reclamacionData);
                }
              } catch (err) {
                console.error('Error al cargar la reclamación asociada:', err);
              }
            }
            
            setFormData({
              nombre: sancionExistente.nombre,
              descripcion: sancionExistente.descripcion,
              puntosPenalizacion: sancionExistente.puntosPenalizacion,
              socioId: sancionExistente.socioId,
              carreraId: sancionExistente.carreraId,
              fechaAplicacion: sancionExistente.fechaAplicacion,
              automatica: sancionExistente.automatica,
              codigoSancion: sancionExistente.codigoSancion || '',
              reclamacionId: sancionExistente.reclamacionId || ''
            });
          } else {
            setError('No se encontró la sanción solicitada');
          }
        } catch (err) {
          console.error('Error al cargar la sanción:', err);
          setError('Error al cargar la sanción');
        } finally {
          setLoading(false);
        }
      }
    };
    
    loadSancion();
  }, [id, data, location.search]);
  
  // Manejar cambios en el formulario
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    
    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else if (name === 'codigoSancion' && value) {
      // Si se selecciona un código de sanción, actualizar automáticamente nombre, descripción y puntos
      const codigoSeleccionado = CODIGOS_SANCIONES[value as keyof typeof CODIGOS_SANCIONES];
      if (codigoSeleccionado) {
        // Buscar la descripción detallada de la infracción en las tablas de sanciones
        let descripcionDetallada = '';
        
        // Mapeo de grupos de códigos a sus descripciones
        const descripcionesPorCodigo: {[key: string]: string} = {
          '1.1': 'Pisar o rebasar las líneas de entrada o salida de box',
          '1.2': 'Contacto peligroso o innecesario',
          '1.3': 'Inclumplimiento "cambio de trazada"',
          '1.4': 'Incumplimiento de las normas de bandera amarilla',
          '1.5': 'No finalizar la carrera en boxes conduciendo',
          '2.1': 'Ganar posición en una acción de doblaje Sin devolver la misma',
          '2.2': 'Accidente leve en todas sus variantes (con ganancia o perdida posición, con y sin daños)',
          '2.3': 'Reiteración Incumplir "cambio la trazada"',
          '2.4': 'Incumplir normas bandera amarilla provocando accidente leve',
          '3.1': 'Incumplir bandera azul "ver normativa"',
          '3.2': 'Accidente grave en todas sus variantes (con ganancia o perdida posición, con y sin daños)',
          '3.3': 'Ocasionar accidente en clasificación',
          '3.4': 'Reincorporarse a pista cuando vienen pilotos cerca sin producir accidente',
          '4.1': 'Más de tres sanciones en la misma carrera o más de tres Warning en el campeonato',
          '4.2': 'Accidente muy grave en todas sus variantes (con ganancia o perdida posición, con y sin daños)',
          '4.3': 'Incumplir las normas de clasificación',
          '4.4': 'Maniobrar después de accidente o trompo, cuando se está dentro de pista y vienen otros pilotos',
          '5.1': 'No llevar operativas las apps obligatorias',
          '5.2': 'Mantener el coche en pista inutilizado por el motivo que sea mas de 6 segundos',
          '5.3': 'Incorporarse a la carrera después de salir de la misma con Escape u otros motivos',
          '5.4': 'Maniobrar marcha atras para reincorporarse a pista',
          '6.1': 'Maniobrar después de accidente o trompo cuando se está dentro de pista y vienen otros pilotos produciendo accidente',
          '6.2': 'Reincorporarse a pista cuando vienen pilotos cerca produciendo accidente',
          '6.3': 'Provocar accidente por culpa de lag u otros motivos técnicos ajenos a la organización',
          '7.1': 'Puntos a restar determinados por comisarios',
          '7.2': 'No hacer la parada obligatoria en la ventana de pit',
          '7.3': 'Agravante por incidente en primera vuelta',
          '7.4': 'Accidente en la primera curva con daños'
        };
        
        // Obtener la descripción detallada si existe
        if (descripcionesPorCodigo[value]) {
          descripcionDetallada = descripcionesPorCodigo[value];
        }
        
        setFormData(prev => ({
          ...prev,
          codigoSancion: value,
          nombre: `Código ${value}`,
          descripcion: `${value} - ${descripcionDetallada}\n\n${codigoSeleccionado.descripcion}`,
          puntosPenalizacion: codigoSeleccionado.puntos
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          codigoSancion: value
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  
  // Guardar sanción
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);
    
    try {
      if (id === 'new') {
        // Crear nueva sanción
        const newSancion = await sancionServiceFirestore.create({
          nombre: formData.nombre,
          descripcion: formData.descripcion,
          puntosPenalizacion: parseInt(formData.puntosPenalizacion.toString()),
          socioId: formData.socioId,
          carreraId: formData.carreraId,
          fechaAplicacion: formData.fechaAplicacion,
          automatica: formData.automatica,
          codigoSancion: formData.codigoSancion,
          reclamacionId: formData.reclamacionId
        });
        
        // Si hay una reclamación asociada, actualizar su estado a 'sancionada'
        if (formData.reclamacionId && newSancion) {
          try {
            await reclamacionServiceFirestore.cambiarEstado(
              formData.reclamacionId, 
              'sancionada', 
              `Sancionado con código ${formData.codigoSancion}: ${formData.puntosPenalizacion} puntos`
            );
          } catch (err) {
            console.error('Error al actualizar el estado de la reclamación:', err);
            // No interrumpir el flujo si falla la actualización de la reclamación
          }
        }
        
        if (newSancion) {
          setSuccess('Sanción creada correctamente');
          setTimeout(() => {
            loadData();
            navigate('/sanciones');
          }, 1500);
        } else {
          setError('Error al crear la sanción');
        }
      } else if (sancion) {
        // Actualizar sanción existente
        const updated = await sancionServiceFirestore.update(sancion.id, {
          nombre: formData.nombre,
          descripcion: formData.descripcion,
          puntosPenalizacion: parseInt(formData.puntosPenalizacion.toString()),
          socioId: formData.socioId,
          carreraId: formData.carreraId,
          fechaAplicacion: formData.fechaAplicacion,
          automatica: formData.automatica,
          codigoSancion: formData.codigoSancion,
          reclamacionId: formData.reclamacionId
        });
        
        if (updated) {
          setSuccess('Sanción actualizada correctamente');
          setTimeout(() => {
            loadData();
            navigate('/sanciones');
          }, 1500);
        } else {
          setError('Error al actualizar la sanción');
        }
      }
    } catch (err) {
      console.error('Error al guardar la sanción:', err);
      setError('Error al guardar la sanción');
    } finally {
      setLoading(false);
    }
  };
  
  // Aplicar sanciones automáticas a una carrera
  const aplicarSancionesAutomaticas = async (carreraId: string) => {
    if (!carreraId) {
      setError('Selecciona una carrera primero');
      return;
    }
    
    if (!window.confirm('¿Estás seguro de que deseas aplicar sanciones automáticas a esta carrera? Esta acción aplicará sanciones basadas en reglas predefinidas.')) {
      return;
    }
    
    setLoading(true);
    setError(null);
    setSuccess(null);
    
    try {
      const sancionesAplicadas = await sancionServiceFirestore.aplicarSancionesAutomaticas(carreraId);
      if (sancionesAplicadas > 0) {
        setSuccess(`Se han aplicado ${sancionesAplicadas} sanciones automáticas correctamente`);
      } else {
        setSuccess('No se encontraron infracciones que requieran sanciones automáticas');
      }
      loadData();
    } catch (err) {
      console.error('Error al aplicar sanciones automáticas:', err);
      setError('Error al aplicar sanciones automáticas');
    } finally {
      setLoading(false);
    }
  };
  
  // Obtener todas las carreras disponibles
  const getCarrerasFiltradas = () => {
    // Si no hay un piloto seleccionado, mostrar todas las carreras
    if (!formData.socioId) {
      return data.carreras;
    }
    
    const socio = data.socios.find(s => s.id === formData.socioId);
    if (!socio) return data.carreras; // Si no se encuentra el socio, mostrar todas las carreras
    
    // Usar la categoría del socio para filtrar las ligas, si tiene categoría
    const categoriaUpper = (socio.Categoria || '').trim().toUpperCase();
    if (!categoriaUpper) return data.carreras; // Si el socio no tiene categoría, mostrar todas las carreras
    
    // Encontrar ligas que coincidan con la categoría del socio
    const ligasIds = data.ligas
      .filter(liga => {
        const ligaCategoriaUpper = (liga.categoria || '').trim().toUpperCase();
        return ligaCategoriaUpper === categoriaUpper;
      })
      .map(liga => liga.id);
    
    // Si no hay ligas que coincidan, mostrar todas las carreras
    if (ligasIds.length === 0) return data.carreras.sort((a, b) => a.nombre.localeCompare(b.nombre));
    
    // Filtrar carreras por las ligas encontradas
    return data.carreras
      .filter(c => ligasIds.includes(c.ligaId))
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
  };
  
  // Agregar un log para depuración
  useEffect(() => {
    console.log('Datos disponibles:', {
      socios: data.socios.length,
      carreras: data.carreras.length,
      ligas: data.ligas.length,
      sociosData: data.socios,
      carrerasData: data.carreras,
      ligasData: data.ligas
    });
  }, [data]);
  
  return (
    <Container>
      <Header>
        <div>
          <BackButton onClick={() => navigate('/sanciones')}>
            <FaArrowLeft />
          </BackButton>
          <Title>
            <FaGavel /> {id === 'new' ? 'Nueva Sanción' : 'Editar Sanción'}
            {reclamacion && <span style={{ fontSize: '1rem', marginLeft: '10px', color: theme.colors.secondary.main }}>(Basada en reclamación)</span>}
          </Title>
        </div>
      </Header>
      
      {id === 'new' && (
        <GuideCard>
          <GuideHeader onClick={() => setGuideOpen(!guideOpen)} style={{ cursor: 'pointer' }}>
            <GuideTitle><FaGavel /> Guía para Comisarios: Sistema de Sanciones</GuideTitle>
            {guideOpen ? (
              <FaArrowUp style={{ color: '#101325' }} />
            ) : (
              <FaArrowDown style={{ color: '#101325' }} />
            )}
          </GuideHeader>
          
          <div style={{ 
            padding: guideOpen ? '20px' : '0', 
            maxHeight: guideOpen ? '3000px' : '0', 
            overflow: 'hidden',
            transition: 'all 0.3s ease-in-out',
            opacity: guideOpen ? '1' : '0'
          }}>
            <GuideSection>
              <p>Bienvenido al Sistema de Comisarios de VRSimracers. Esta guía te ayudará a entender los tipos de sanciones disponibles y cómo utilizarlas correctamente.</p>
            </GuideSection>
            
            <SanctionCardsContainer>
              <SanctionCategoryCard>
                <CategoryHeader>leves</CategoryHeader>
                <CategoryPenalty>WARNING</CategoryPenalty>
              </SanctionCategoryCard>
              
              <SanctionCategoryCard>
                <CategoryHeader>medias</CategoryHeader>
                <CategoryPenalty>-1 PT. EN LA GENERAL +W</CategoryPenalty>
              </SanctionCategoryCard>
              
              <SanctionCategoryCard>
                <CategoryHeader>graves</CategoryHeader>
                <CategoryPenalty>-2 PTS. EN LA GENERAL +W</CategoryPenalty>
              </SanctionCategoryCard>
              
              <SanctionCategoryCard>
                <CategoryHeader>muy graves</CategoryHeader>
                <CategoryPenalty>DT</CategoryPenalty>
              </SanctionCategoryCard>
              
              <SanctionCategoryCard>
                <CategoryHeader>ANITDEPORTIVA</CategoryHeader>
                <CategoryPenalty>DT + DQ</CategoryPenalty>
              </SanctionCategoryCard>
              
              <SanctionCategoryCard>
                <CategoryHeader>ANTID. CON ACCIDENTE</CategoryHeader>
                <CategoryPenalty>DT + DQ + NQ</CategoryPenalty>
              </SanctionCategoryCard>
              
              <SanctionCategoryCard>
                <CategoryHeader>otras</CategoryHeader>
                <CategoryPenalty>A DETERMINAR</CategoryPenalty>
              </SanctionCategoryCard>
            </SanctionCardsContainer>
            
            <h4 style={{ marginTop: '30px', marginBottom: '15px', color: '#101325' }}>Infracciones por Categoría</h4>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
              <h5 style={{ margin: 0, color: '#101325' }}>Grupo 1 - Leves</h5>
            </div>
            
            <SanctionsTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.1</td>
                  <td>Pisar o rebasar las líneas de entrada o salida de box</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.2</td>
                  <td>Contacto peligroso o innecesario</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.3</td>
                  <td>Inclumplimiento "cambio de trazada"</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.4</td>
                  <td>Incumplimiento de las normas de bandera amarilla</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.5</td>
                  <td>No finalizar la carrera en boxes conduciendo</td>
                  <td>WARNING</td>
                </tr>
              </tbody>
            </SanctionsTable>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '15px' }}>
              <h5 style={{ margin: 0, color: '#101325' }}>Grupo 2 - Medias</h5>
            </div>
            
            <SanctionsTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2.1</td>
                  <td>Ganar posición en una acción de doblaje Sin devolver la misma</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>2.2</td>
                  <td>Accidente leve en todas sus variantes (con ganancia o perdida posición, con y sin daños)</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>2.3</td>
                  <td>Reiteración Incumplir "cambio la trazada"</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>2.4</td>
                  <td>Incumplir normas bandera amarilla provocando accidente leve</td>
                  <td>-1 PT + WARNING</td>
                </tr>
              </tbody>
            </SanctionsTable>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '15px' }}>
              <h5 style={{ margin: 0, color: '#101325' }}>Grupo 3 - Graves</h5>
            </div>
            
            <SanctionsTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>3.1</td>
                  <td>Incumplir bandera azul "ver normativa"</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
                <tr>
                  <td>3.2</td>
                  <td>Accidente grave en todas sus variantes (con ganancia o perdida posición, con y sin daños)</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
                <tr>
                  <td>3.3</td>
                  <td>Ocasionar accidente en clasificación</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
                <tr>
                  <td>3.4</td>
                  <td>Reincorporarse a pista cuando vienen pilotos cerca sin producir accidente</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
              </tbody>
            </SanctionsTable>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '15px' }}>
              <h5 style={{ margin: 0, color: '#101325' }}>Grupo 4 - Muy Graves</h5>
            </div>
            
            <SanctionsTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>4.1</td>
                  <td>Más de tres sanciones en la misma carrera o más de tres Warning en el campeonato</td>
                  <td>+DT</td>
                </tr>
                <tr>
                  <td>4.2</td>
                  <td>Accidente muy grave en todas sus variantes (con ganancia o perdida posición, con y sin daños)</td>
                  <td>+DT</td>
                </tr>
                <tr>
                  <td>4.3</td>
                  <td>Incumplir las normas de clasificación</td>
                  <td>+DT</td>
                </tr>
                <tr>
                  <td>4.4</td>
                  <td>Maniobrar después de accidente o trompo, cuando se está dentro de pista y vienen otros pilotos</td>
                  <td>+DT</td>
                </tr>
              </tbody>
            </SanctionsTable>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '15px' }}>
              <h5 style={{ margin: 0, color: '#101325' }}>Grupo 5 - Antideportivas</h5>
            </div>
            
            <SanctionsTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>5.1</td>
                  <td>No llevar operativas las apps obligatorias</td>
                  <td>+DT + DQ</td>
                </tr>
                <tr>
                  <td>5.2</td>
                  <td>Mantener el coche en pista inutilizado por el motivo que sea mas de 6 segundos</td>
                  <td>+DT + DQ</td>
                </tr>
                <tr>
                  <td>5.3</td>
                  <td>Incorporarse a la carrera después de salir de la misma con Escape u otros motivos</td>
                  <td>+DT + DQ</td>
                </tr>
                <tr>
                  <td>5.4</td>
                  <td>Maniobrar marcha atras para reincorporarse a pista</td>
                  <td>+DT + DQ</td>
                </tr>
              </tbody>
            </SanctionsTable>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '15px' }}>
              <h5 style={{ margin: 0, color: '#101325' }}>Grupo 6 - Antideportivas con Accidente</h5>
            </div>
            
            <SanctionsTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>6.1</td>
                  <td>Maniobrar después de accidente o trompo cuando se está dentro de pista y vienen otros pilotos produciendo accidente</td>
                  <td>+DT + DQ + NQ</td>
                </tr>
                <tr>
                  <td>6.2</td>
                  <td>Reincorporarse a pista cuando vienen pilotos cerca produciendo accidente</td>
                  <td>+DT + DQ + NQ</td>
                </tr>
                <tr>
                  <td>6.3</td>
                  <td>Provocar accidente por culpa de lag u otros motivos técnicos ajenos a la organización</td>
                  <td>+DT + DQ + NQ</td>
                </tr>
              </tbody>
            </SanctionsTable>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '15px' }}>
              <h5 style={{ margin: 0, color: '#101325' }}>Grupo 7 - Otras</h5>
            </div>
            
            <SanctionsTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>7.1</td>
                  <td>Puntos a restar determinados por comisarios</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>7.2</td>
                  <td>No hacer la parada obligatoria en la ventana de pit</td>
                  <td>-2 puntos + DT</td>
                </tr>
                <tr>
                  <td>7.3</td>
                  <td>Agravante por incidente en primera vuelta</td>
                  <td>Incremento de un nivel de sanción</td>
                </tr>
                <tr>
                  <td>7.4</td>
                  <td>Accidente en la primera curva con daños</td>
                  <td>-2 PTS + WARNING + DT</td>
                </tr>
              </tbody>
            </SanctionsTable>
          
          <GuideSection>
            <GuideSectionTitle><FaRobot /> Sanciones Automáticas</GuideSectionTitle>
            <p>Las sanciones automáticas son aplicadas por el sistema sin intervención de los comisarios, basándose en reglas configurables. Estas sanciones se aplican a infracciones detectadas automáticamente durante la carrera.</p>
            
            <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px solid #e9ecef' }}>
              <p style={{ fontWeight: 'bold', color: theme.colors.primary.main, marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                <FaInfoCircle style={{ marginRight: '8px' }} /> Reglas configurables
              </p>
              <p>Los comisarios pueden configurar las reglas de sanciones automáticas, definiendo qué infracciones serán sancionadas y cuántos puntos se restarán por cada una.</p>
              <Button 
                as="a" 
                href="/sanciones/reglas-automaticas" 
                style={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  marginTop: '10px',
                  textDecoration: 'none',
                  backgroundColor: theme.colors.primary.main,
                  color: 'white',
                  padding: '8px 15px',
                  borderRadius: '4px',
                  fontSize: '0.9rem',
                  fontWeight: 500
                }}
              >
                <FaRobot style={{ marginRight: '8px' }} /> Configurar reglas
              </Button>
            </div>
            
            <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>Ejemplos de infracciones que pueden ser sancionadas automáticamente:</p>
            <ul>
              <li><strong>DNF (No terminó la carrera):</strong> Penalización por abandonar o no terminar la carrera.</li>
              <li><strong>No participación:</strong> Penalización por estar inscrito pero no participar en la carrera.</li>
              <li><strong>Exceso de incidentes:</strong> Penalización por superar un umbral de incidentes durante la carrera.</li>
              <li><strong>Exceso de salidas de pista:</strong> Penalización por salirse de los límites de la pista repetidamente.</li>
            </ul>
            
            <p style={{ marginTop: '15px' }}><strong>Beneficios:</strong></p>
            <ul>
              <li>Aplicación consistente y objetiva de las reglas.</li>
              <li>Reducción de la carga de trabajo para los comisarios.</li>
              <li>Transparencia en el proceso de sanción.</li>
              <li>Respuesta inmediata a infracciones detectadas.</li>
            </ul>
          </GuideSection>
          
          <GuideSection>
            <GuideSectionTitle><FaUserEdit /> Sanciones Manuales</GuideSectionTitle>
            <p>Las sanciones manuales son aplicadas por los comisarios después de revisar incidentes que requieren interpretación y juicio humano.</p>
            
            <GuideList>
              <li><strong>Incidentes de carrera:</strong> Colisiones, bloqueos, maniobras peligrosas, etc.</li>
              <li><strong>Comportamiento antideportivo:</strong> Acciones deliberadas para perjudicar a otros pilotos.</li>
              <li><strong>Infracciones de reglamento:</strong> Violaciones de normas específicas de la competición.</li>
              <li><strong>Protestas:</strong> Sanciones aplicadas tras la revisión de una protesta presentada por otro piloto.</li>
            </GuideList>
            
            <p><strong>Características:</strong></p>
            <ul>
              <li>Totalmente personalizables en nombre, descripción y puntos de penalización.</li>
              <li>Requieren evaluación y criterio de los comisarios.</li>
              <li>Pueden ser modificadas o revocadas si se presenta nueva evidencia.</li>
              <li>Permiten flexibilidad para adaptarse a circunstancias específicas.</li>
            </ul>
          </GuideSection>
          
          <GuideSection>
            <GuideSectionTitle><FaExclamationTriangle /> Comparativa entre Sanciones Automáticas y Manuales</GuideSectionTitle>
            
            <ComparisonTable>
              <thead>
                <tr>
                  <th>Característica</th>
                  <th>Sanciones Automáticas</th>
                  <th>Sanciones Manuales</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Aplicación</td>
                  <td className="automatic">Por el sistema</td>
                  <td className="manual">Por comisarios</td>
                </tr>
                <tr>
                  <td>Modificación</td>
                  <td className="automatic">No modificables</td>
                  <td className="manual">Totalmente modificables</td>
                </tr>
                <tr>
                  <td>Tiempo de aplicación</td>
                  <td className="automatic">Inmediato tras procesar resultados</td>
                  <td className="manual">Después de revisión y deliberación</td>
                </tr>
                <tr>
                  <td>Criterio</td>
                  <td className="automatic">Basado en datos objetivos</td>
                  <td className="manual">Basado en interpretación y reglamento</td>
                </tr>
                <tr>
                  <td>Casos de uso</td>
                  <td className="automatic">DNF, DNS, infracciones técnicas medibles</td>
                  <td className="manual">Incidentes, comportamiento, protestas</td>
                </tr>
              </tbody>
            </ComparisonTable>
          </GuideSection>
          
          <GuideSection>
            <GuideSectionTitle><FaList /> Sistema de Códigos de Sanciones VRSimracers</GuideSectionTitle>
            <p>VRSimracers utiliza un sistema estandarizado de códigos de sanciones para garantizar la consistencia y transparencia en las decisiones de los comisarios. Estos códigos están organizados por categorías y niveles de gravedad:</p>
            
            <div style={{ marginBottom: '15px' }}>
              <strong>Clasificación de Infracciones:</strong>
              <ul>
                <li><strong>Leves:</strong> WARNING</li>
                <li><strong>Medias:</strong> -1 PT. EN LA GENERAL +W</li>
                <li><strong>Graves:</strong> -2 PTS. EN LA GENERAL +W</li>
                <li><strong>Muy graves:</strong> DT</li>
                <li><strong>Antideportiva:</strong> DT + DQ</li>
                <li><strong>Antid. con accidente:</strong> DT + DQ + NQ</li>
                <li><strong>Otras:</strong> A DETERMINAR</li>
              </ul>
            </div>
            
            <ComparisonTable>
              <thead>
                <tr>
                  <th>Categoría</th>
                  <th>Códigos</th>
                  <th>Descripción</th>
                  <th>Penalización</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Advertencias</td>
                  <td>1.1 - 1.5</td>
                  <td>Infracciones leves que merecen advertencia</td>
                  <td>Warning (sin puntos)</td>
                </tr>
                <tr>
                  <td>Infracciones menores</td>
                  <td>2.1 - 2.5</td>
                  <td>Infracciones que afectan levemente la carrera</td>
                  <td>-1 punto + Warning</td>
                </tr>
                <tr>
                  <td>Infracciones moderadas</td>
                  <td>3.1 - 3.5</td>
                  <td>Infracciones con impacto moderado</td>
                  <td>-2 puntos + Warning</td>
                </tr>
                <tr>
                  <td>Infracciones graves (DT)</td>
                  <td>4.1 - 4.5</td>
                  <td>Infracciones graves con penalización Drive Through</td>
                  <td>+DT (-3 puntos)</td>
                </tr>
                <tr>
                  <td>Infracciones muy graves</td>
                  <td>5.1 - 5.5</td>
                  <td>Infracciones que ameritan descalificación</td>
                  <td>+DT + DQ (-4 puntos)</td>
                </tr>
                <tr>
                  <td>Infracciones críticas</td>
                  <td>6.1 - 6.5</td>
                  <td>Infracciones extremadamente graves</td>
                  <td>+DT + DQ + NQ (-5 puntos)</td>
                </tr>
                <tr>
                  <td>Casos especiales</td>
                  <td>7.x, 8.x</td>
                  <td>Infracciones específicas con penalizaciones personalizadas</td>
                  <td>Variable</td>
                </tr>
                <tr>
                  <td>Ajustes FPS</td>
                  <td>9.1 - 9.6</td>
                  <td>Ajustes técnicos relacionados con FPS</td>
                  <td>-3 a +3 puntos</td>
                </tr>
                <tr>
                  <td>Revocaciones</td>
                  <td>0.1 - 0.7</td>
                  <td>Levantamiento de sanciones previas</td>
                  <td>0 a +5 puntos</td>
                </tr>
              </tbody>
            </ComparisonTable>
            
            <p><strong>Abreviaturas:</strong></p>
            <ul>
              <li><strong>DT:</strong> Drive Through - Penalización que requiere pasar por pit lane</li>
              <li><strong>DQ:</strong> Descalificación - Exclusión de los resultados de la carrera</li>
              <li><strong>NQ:</strong> No Qualifying - Prohibición de participar en la siguiente clasificación</li>
              <li><strong>FPS:</strong> Frames Per Second - Ajustes relacionados con la configuración técnica</li>
              <li><strong>W:</strong> Warning - Advertencia</li>
            </ul>
            
            <p>Para aplicar una sanción utilizando este sistema, selecciona el código apropiado en el selector de códigos de sanción al inicio del formulario.</p>
          </GuideSection>
          
          <GuideSection>
            <GuideSectionTitle><FaList /> Descripción Detallada de Infracciones</GuideSectionTitle>
            
            <ComparisonTable>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción de la Infracción</th>
                  <th>Sanción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.1</td>
                  <td>Pisar o rebasar las líneas de entrada o salida de box</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.2</td>
                  <td>Contacto peligroso o innecesario</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.3</td>
                  <td>Inclumplimiento "cambio de trazada"</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.4</td>
                  <td>Incumplimiento de las normas de bandera amarilla</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>1.5</td>
                  <td>No finalizar la carrera en boxes conduciendo</td>
                  <td>WARNING</td>
                </tr>
                <tr>
                  <td>2.1</td>
                  <td>Ganar posición en una acción de doblaje sin devolver la misma</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>2.2</td>
                  <td>Accidente leve en todas sus variantes</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>2.3</td>
                  <td>Reiteración Incumplir "cambio la trazada"</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>2.4</td>
                  <td>Incumplir normas bandera amarilla provocando accidente leve</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>3.1</td>
                  <td>Incumplir bandera azul "ver normativa"</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
                <tr>
                  <td>3.2</td>
                  <td>Accidente grave en todas sus variantes</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
                <tr>
                  <td>3.3</td>
                  <td>Ocasionar accidente en clasificación</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
                <tr>
                  <td>3.4</td>
                  <td>Reincorporarse a pista cuando vienen pilotos cerca sin producir accidente</td>
                  <td>-2 PTS + WARNING</td>
                </tr>
                <tr>
                  <td>4.1</td>
                  <td>Más de tres sanciones en la misma carrera o más de tres Warning en el campeonato</td>
                  <td>+DT</td>
                </tr>
                <tr>
                  <td>4.2</td>
                  <td>Accidente muy grave en todas sus variantes</td>
                  <td>+DT</td>
                </tr>
                <tr>
                  <td>4.3</td>
                  <td>Incumplir las normas de clasificación</td>
                  <td>+DT</td>
                </tr>
                <tr>
                  <td>4.4</td>
                  <td>Maniobrar después de accidente o trompo, cuando se está dentro de pista y vienen otros pilotos</td>
                  <td>+DT</td>
                </tr>
                <tr>
                  <td>5.1</td>
                  <td>No llevar operativas las apps obligatorias</td>
                  <td>+DT + DQ</td>
                </tr>
                <tr>
                  <td>5.2</td>
                  <td>Mantener el coche en pista inutilizado por el motivo que sea mas de 6 segundos</td>
                  <td>+DT + DQ</td>
                </tr>
                <tr>
                  <td>5.3</td>
                  <td>Incorporarse a la carrera después de salir de la misma con Escape u otros motivos</td>
                  <td>+DT + DQ</td>
                </tr>
                <tr>
                  <td>5.4</td>
                  <td>Maniobrar marcha atras para reincorporarse a pista</td>
                  <td>+DT + DQ</td>
                </tr>
                <tr>
                  <td>6.1</td>
                  <td>Maniobrar después de accidente o trompo cuando se está dentro de pista y vienen otros pilotos produciendo accidente</td>
                  <td>+DT + DQ + NQ</td>
                </tr>
                <tr>
                  <td>6.2</td>
                  <td>Reincorporarse a pista cuando vienen pilotos cerca produciendo accidente</td>
                  <td>+DT + DQ + NQ</td>
                </tr>
                <tr>
                  <td>6.3</td>
                  <td>Provocar accidente por culpa de lag u otros motivos técnicos ajenos a la organización</td>
                  <td>+DT + DQ + NQ</td>
                </tr>
                <tr>
                  <td>7.1</td>
                  <td>Puntos a restar determinados por comisarios</td>
                  <td>-1 PT + WARNING</td>
                </tr>
                <tr>
                  <td>7.2</td>
                  <td>No hacer la parada obligatoria en la ventana de pit</td>
                  <td>A DETERMINAR</td>
                </tr>
                <tr>
                  <td>7.3</td>
                  <td>Agravante por incidente en primera vuelta</td>
                  <td>Incremento de un nivel de sanción</td>
                </tr>
                <tr>
                  <td>7.4</td>
                  <td>Accidente en la primera curva con daños</td>
                  <td>-2 PTS + WARNING + DT</td>
                </tr>
              </tbody>
            </ComparisonTable>
          </GuideSection>
          
          <GuideSection>
            <GuideSectionTitle><FaGavel /> Recomendaciones para Comisarios</GuideSectionTitle>
            <ol>
              <li>Revisa siempre las repeticiones desde múltiples ángulos antes de emitir un juicio.</li>
              <li>Aplica el reglamento de forma consistente para todos los pilotos.</li>
              <li>Considera el contexto y las circunstancias del incidente.</li>
              <li>Documenta claramente la razón de la sanción en la descripción.</li>
              <li>Utiliza el sistema de códigos de sanciones para mantener la consistencia.</li>
              <li>Mantén la imparcialidad y objetividad en todas las decisiones.</li>
            </ol>
          </GuideSection>
          </div>
        </GuideCard>
      )}
      
      {error && (
        <WarningMessage>
          <FaExclamationTriangle style={{ marginRight: '8px' }} />
          {error}
        </WarningMessage>
      )}
      
      {success && (
        <InfoMessage style={{ backgroundColor: '#d4edda', borderLeftColor: '#28a745', color: '#155724' }}>
          {success}
        </InfoMessage>
      )}
      
      {/* Sección de detalles de la reclamación si existe */}
      {reclamacion && (
        <ReclamacionCard>
          <ReclamacionHeader onClick={() => setReclamacionDetallesOpen(!reclamacionDetallesOpen)}>
            <div>
              <FaFileAlt style={{ marginRight: '10px' }} />
              Detalles de la Reclamación
            </div>
            <div>
              {reclamacionDetallesOpen ? <FaArrowUp /> : <FaArrowDown />}
            </div>
          </ReclamacionHeader>
          
          {reclamacionDetallesOpen && (
            <ReclamacionBody>
              <ReclamacionInfo>
                <ReclamacionInfoItem>
                  <strong>Fecha:</strong> {reclamacion.fechaReclamacion}
                </ReclamacionInfoItem>
                <ReclamacionInfoItem>
                  <strong>Liga:</strong> {data.ligas.find(l => l.id === reclamacion.ligaId)?.nombre || 'Desconocida'}
                </ReclamacionInfoItem>
                <ReclamacionInfoItem>
                  <strong>Carrera:</strong> {data.carreras.find(c => c.id === reclamacion.carreraId)?.nombre || 'Desconocida'}
                </ReclamacionInfoItem>
                <ReclamacionInfoItem>
                  <strong>Piloto Reclamante:</strong> {
                    (() => {
                      const socio = data.socios.find(s => s.id === reclamacion.reclamanteSocioId);
                      return socio ? (socio.display_name || socio.user_login || (socio.nombre && socio.apellido ? `${socio.nombre} ${socio.apellido}` : 'Piloto sin nombre')) : 'Desconocido';
                    })()
                  }
                </ReclamacionInfoItem>
                <ReclamacionInfoItem>
                  <strong>Piloto Reclamado:</strong> {
                    (() => {
                      const socio = data.socios.find(s => s.id === reclamacion.reclamadoSocioId);
                      return socio ? (socio.display_name || socio.user_login || (socio.nombre && socio.apellido ? `${socio.nombre} ${socio.apellido}` : 'Piloto sin nombre')) : 'Desconocido';
                    })()
                  }
                </ReclamacionInfoItem>
                <ReclamacionInfoItem>
                  <strong>Tipo de Incidente:</strong> {
                    (() => {
                      switch(reclamacion.tipoIncidente) {
                        case 'golpe': return 'Golpe';
                        case 'salida_pista': return 'Salida de Pista';
                        case 'bloqueo': return 'Bloqueo';
                        case 'comportamiento_antideportivo': return 'Comportamiento Antideportivo';
                        default: return 'Otro';
                      }
                    })()
                  }
                </ReclamacionInfoItem>
                {reclamacion.vuelta && (
                  <ReclamacionInfoItem>
                    <strong>Vuelta:</strong> {reclamacion.vuelta}
                  </ReclamacionInfoItem>
                )}
                {(reclamacion.minutoIncidente !== undefined || reclamacion.segundoIncidente !== undefined) && (
                  <ReclamacionInfoItem>
                    <strong>Tiempo del incidente:</strong> {
                      `${reclamacion.minutoIncidente !== undefined ? reclamacion.minutoIncidente + '"' : '0"'}${reclamacion.segundoIncidente !== undefined ? reclamacion.segundoIncidente.toFixed(3) : '0.000'}`
                    }
                  </ReclamacionInfoItem>
                )}
              </ReclamacionInfo>
              
              <ReclamacionDescription>
                <strong>Motivo:</strong> {reclamacion.motivo}
              </ReclamacionDescription>
              
              <ReclamacionDescription>
                <strong>Descripción:</strong> {reclamacion.descripcion}
              </ReclamacionDescription>
              
              {reclamacion.evidencias && reclamacion.evidencias.length > 0 && (
                <ReclamacionEvidencias>
                  <strong>Evidencias:</strong>
                  <ul>
                    {reclamacion.evidencias.map((evidencia, index) => (
                      <li key={index}>
                        <a href={evidencia} target="_blank" rel="noopener noreferrer">
                          <FaImage style={{ marginRight: '5px' }} />
                          {evidencia.split('/').pop()}
                        </a>
                      </li>
                    ))}
                  </ul>
                </ReclamacionEvidencias>
              )}
            </ReclamacionBody>
          )}
        </ReclamacionCard>
      )}
      
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="codigoSancion">
            Código de Sanción 
            <span style={{ color: '#e4312e', marginLeft: '5px', fontSize: '0.9em' }}>
              
            </span>
          </Label>
          <Select
            id="codigoSancion"
            name="codigoSancion"
            value={formData.codigoSancion}
            onChange={handleChange}
            disabled={loading || formData.automatica}
          >
            <option value="">Selecciona un código de sanción</option>
            {Object.entries(CODIGOS_SANCIONES).map(([codigo, info]) => (
              <option key={codigo} value={codigo}>
                {codigo} - {info.descripcion} ({info.puntos} {info.puntos === 1 ? 'punto' : 'puntos'})
              </option>
            ))}
          </Select>
          <small style={{ display: 'block', marginTop: '5px', color: '#101325' }}>
            <FaInfoCircle style={{ marginRight: '5px' }} /> 
            Al seleccionar un código, se rellenarán automáticamente el nombre, la descripción y los puntos de penalización.
          </small>
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="nombre">Nombre de la sanción</Label>
          <Input
            type="text"
            id="nombre"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
            disabled={loading || formData.automatica}
            placeholder="Ej: Incidente en curva 1"
          />
          {formData.automatica && (
            <small style={{ display: 'block', marginTop: '5px', color: '#101325' }}>
              <FaRobot style={{ marginRight: '5px' }} /> Las sanciones automáticas no pueden ser renombradas
            </small>
          )}
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="descripcion">Descripción</Label>
          <TextArea
            id="descripcion"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            disabled={loading || formData.automatica}
            placeholder="Describe los detalles de la sanción"
          />
          {formData.automatica && (
            <small style={{ display: 'block', marginTop: '5px', color: '#0f3460' }}>
              <FaRobot style={{ marginRight: '5px' }} /> La descripción de sanciones automáticas no puede ser modificada
            </small>
          )}
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="puntosPenalizacion">Puntos de penalización</Label>
          <Input
            type="number"
            id="puntosPenalizacion"
            name="puntosPenalizacion"
            value={formData.puntosPenalizacion}
            onChange={handleChange}
            required
            disabled={loading || formData.automatica}
          />
          <small style={{ display: 'block', marginTop: '5px', color: '#6c757d' }}>
            Usa valores negativos para restar puntos y valores positivos para sumar puntos.
            {formData.automatica && (
              <span style={{ display: 'block', marginTop: '5px', color: '#0f3460' }}>
                <FaRobot style={{ marginRight: '5px' }} /> Los puntos de penalización de sanciones automáticas no pueden ser modificados
              </span>
            )}
          </small>
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="socioId">Piloto</Label>
          <Select
            id="socioId"
            name="socioId"
            value={formData.socioId}
            onChange={handleChange}
            required
            disabled={loading || (id !== 'new' && formData.automatica)}
          >
            <option value="">Selecciona un piloto {data.socios.length > 0 ? `(${data.socios.length} disponibles)` : '(No hay pilotos disponibles)'}</option>
            {data.socios && data.socios.length > 0 ? 
              data.socios.map(socio => {
                // Determinar el nombre a mostrar en orden de prioridad
                const nombreMostrado = socio.display_name || 
                                      (socio.nombre && socio.apellido ? `${socio.nombre} ${socio.apellido}` : null) ||
                                      socio.NOMBRE_CORTO || 
                                      socio.NOMBRE_SERVERS_VRS || 
                                      'Sin nombre';
                
                return (
                  <option key={socio.id} value={socio.id}>
                    {nombreMostrado} {socio.Categoria ? `(${socio.Categoria})` : ''}
                  </option>
                );
              })
            : 
              <option disabled>No hay pilotos disponibles</option>
            }
          </Select>
          {id !== 'new' && formData.automatica && (
            <small style={{ display: 'block', marginTop: '5px', color: '#0f3460' }}>
              <FaRobot style={{ marginRight: '5px' }} /> El piloto de una sanción automática no puede ser cambiado
            </small>
          )}
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="carreraId">Carrera</Label>
          <Select
            id="carreraId"
            name="carreraId"
            value={formData.carreraId}
            onChange={handleChange}
            disabled={loading || (id !== 'new' && formData.automatica)}
          >
            <option value="">General (no asociada a una carrera específica)</option>
            {getCarrerasFiltradas().length > 0 ? 
              getCarrerasFiltradas().map(carrera => (
                <option key={carrera.id} value={carrera.id}>
                  {carrera.nombre || 'Sin nombre'} ({carrera.fecha || 'Sin fecha'})
                </option>
              ))
            : 
              <option disabled>{data.carreras.length > 0 ? 'No hay carreras para la categoría seleccionada' : 'No hay carreras disponibles'}</option>
            }
          </Select>
          {id !== 'new' && formData.automatica && (
            <small style={{ display: 'block', marginTop: '5px', color: '#0f3460' }}>
              <FaRobot style={{ marginRight: '5px' }} /> La carrera de una sanción automática no puede ser cambiada
            </small>
          )}
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="fechaAplicacion">Fecha de aplicación</Label>
          <Input
            type="date"
            id="fechaAplicacion"
            name="fechaAplicacion"
            value={formData.fechaAplicacion}
            onChange={handleChange}
            required
            disabled={loading || formData.automatica}
          />
          {formData.automatica && (
            <small style={{ display: 'block', marginTop: '5px', color: '#0f3460' }}>
              <FaRobot style={{ marginRight: '5px' }} /> La fecha de una sanción automática no puede ser modificada
            </small>
          )}
        </FormGroup>
        
        {id === 'new' && (
          <Checkbox>
            <input
              type="checkbox"
              id="automatica"
              name="automatica"
              checked={formData.automatica}
              onChange={handleChange}
              disabled={loading}
            />
            <Label htmlFor="automatica" style={{ display: 'inline', marginLeft: '5px' }}>
              Sanción automática <FaRobot style={{ marginLeft: '5px', fontSize: '0.8rem' }} />
            </Label>
          </Checkbox>
        )}
        
        <ButtonGroup>
          <Button type="submit" disabled={loading}>
            <FaSave /> {id === 'new' ? 'Crear Sanción' : 'Actualizar Sanción'}
          </Button>
          <BackButton type="button" onClick={() => navigate('/sanciones')} disabled={loading}>
            <FaArrowLeft /> Volver
          </BackButton>
        </ButtonGroup>
      </Form>
      
      {formData.carreraId && id === 'new' && (
        <Card>
          <CardTitle>
            <FaGavel /> Sanciones automáticas
          </CardTitle>
          <p>
            Puedes aplicar sanciones automáticas a la carrera seleccionada. Esto aplicará sanciones basadas en reglas predefinidas, como:
          </p>
          <ul style={{ marginBottom: '15px' }}>
            <li><strong>DNF (No terminó la carrera):</strong> -1 punto de penalización</li>
            <li><strong>Otras infracciones:</strong> Según las reglas configuradas en el sistema</li>
          </ul>
          <ActionButton 
            type="button" 
            onClick={() => aplicarSancionesAutomaticas(formData.carreraId)}
            disabled={loading}
          >
            <FaRobot style={{ marginRight: '8px' }} /> Aplicar sanciones automáticas
          </ActionButton>
        </Card>
      )}
    </Container>
  );
};

export default SancionDetail;